<template>
  <div :class="$attrs.class">
    <div class="flex flex-col justify-between items-center w-full relative" :class="{'sm:flex-row' : row}">
      <label v-if="label" class="form-label w-full mb-2" :for="id">{{ label }}:</label>
      <HeroIcon :name="modelValue" custom-icon class="mr-1 w-10 h-10" :fill="selected == 'urlaub' ? '#6CBE7B' : (selected == 'homeoffice' ? '#27AE60' : '#3498DB')" />
      <select :id="id" ref="input" v-model="selected" v-bind="{ ...$attrs, class: null }" class="form-select outline-none focus-within:outline-none" :class="{ error: error }, pre == null && modelValue == null ? 'text-orfRed-100':'', {'border border-büro-100' : modelValue == 'büro'}, {'border border-urlaub-100' : modelValue == 'urlaub'}, {'w-min' : minW} ">
        <slot />
      </select>
      <div v-if="error" class="form-error absolute top-2 text-xs px-2 right-2 transform bg-white whitespace-normal" style="max-width: 350px">{{ error }}</div>
    </div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
import HeroIcon from '@/Shared/HeroIcon.vue'
export default {
  components: {HeroIcon},
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `select-input-${uuid()}`
      },
    },
    icon: String,
    error: String,
    row: {
      type: Boolean,
      default() {
        return false;
      }
    },
    minW: {
      type: Boolean,
      default() {
        return false;
      }
    },
    label: String,
    modelValue: [String, Number, Boolean],
    pre: [String, Number],
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selected: this.pre,
    }
  },
  watch: {
    selected(selected) {
      this.$emit('update:modelValue', selected)
    },
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
  },
}
</script>
